import { render, staticRenderFns } from "./HomePostsCards.vue?vue&type=template&id=70059f9d&scoped=true&"
import script from "./HomePostsCards.vue?vue&type=script&lang=js&"
export * from "./HomePostsCards.vue?vue&type=script&lang=js&"
import style0 from "./HomePostsCards.vue?vue&type=style&index=0&id=70059f9d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70059f9d",
  null
  
)

export default component.exports